// Utilitaires pour communiquer avec Electron
import { isElectron, isWeb } from './platform';

declare global {
    interface Window {
        require?: any;
    }
}

export const quitApplication = () => {
    // Émettre un événement pour déclencher l'animation d'extinction
    window.dispatchEvent(new CustomEvent('SYSTEM_SHUTDOWN_REQUESTED'));
};

export const forceQuitApplication = () => {
    try {
        // Vérifier si on est dans Electron
        if (isElectron() && window.require) {
            const { ipcRenderer } = window.require('electron');
            ipcRenderer.send('quit-app');
        } else if (isWeb()) {
            // Version web : émettre un événement pour retourner à l'écran de démarrage
            window.dispatchEvent(new CustomEvent('SYSTEM_SHUTDOWN_REQUESTED'));
        } else {
            // Fallback pour le navigateur (développement)
            console.log('Fermeture de l\'application (mode navigateur)');
            if (isWeb()) {
                window.dispatchEvent(new CustomEvent('SYSTEM_SHUTDOWN_REQUESTED'));
            } else {
                window.close();
            }
        }
    } catch (e) {
        console.warn('Impossible de fermer l\'application:', e);
        // Fallback ultime
        if (isWeb()) {
            window.dispatchEvent(new CustomEvent('SYSTEM_SHUTDOWN_REQUESTED'));
        } else {
            window.close();
        }
    }
};

export const toggleFullscreen = () => {
    try {
        // Vérifier si on est dans Electron
        if (isElectron() && window.require) {
            const { ipcRenderer } = window.require('electron');
            ipcRenderer.send('toggle-fullscreen');
        } else {
            // Fallback pour le navigateur (API Fullscreen standard)
            if (!document.fullscreenElement) {
                document.documentElement.requestFullscreen();
            } else {
                document.exitFullscreen();
            }
        }
    } catch (e) {
        console.warn('Impossible de basculer le plein écran:', e);
    }
};

export const setFullscreen = (fullscreen: boolean) => {
    console.log('setFullscreen appelé avec:', fullscreen);
    
    // Gérer la classe CSS pour la zone de déplacement
    if (fullscreen) {
        document.body.classList.add('fullscreen-mode');
    } else {
        document.body.classList.remove('fullscreen-mode');
    }
    
    try {
        // Vérifier si on est dans Electron
        console.log('window.require disponible:', !!window.require);
        if (isElectron() && window.require) {
            try {
                const { ipcRenderer } = window.require('electron');
                console.log('ipcRenderer obtenu:', !!ipcRenderer);
                console.log('Envoi du message IPC set-fullscreen:', fullscreen);
                ipcRenderer.send('set-fullscreen', fullscreen);
                console.log('Message IPC envoyé avec succès');
                
                // Ajouter un délai pour vérifier si le changement a eu lieu
                setTimeout(() => {
                    console.log('Vérification du changement de plein écran côté React...');
                }, 200);
            } catch (electronError) {
                console.error('Erreur lors de l\'utilisation d\'Electron IPC:', electronError);
                // Fallback vers l'API navigateur
                handleBrowserFullscreen(fullscreen);
            }
        } else {
            console.log('Mode navigateur détecté - utilisation de l\'API Fullscreen standard');
            handleBrowserFullscreen(fullscreen);
        }
    } catch (e) {
        console.warn('Impossible de définir le mode plein écran:', e);
        // Fallback ultime
        handleBrowserFullscreen(fullscreen);
    }
};

const handleBrowserFullscreen = (fullscreen: boolean) => {
    if (fullscreen && !document.fullscreenElement) {
        document.documentElement.requestFullscreen().then(() => {
            console.log('Plein écran activé (navigateur)');
        }).catch(err => {
            console.error('Erreur activation plein écran (navigateur):', err);
        });
    } else if (!fullscreen && document.fullscreenElement) {
        document.exitFullscreen().then(() => {
            console.log('Plein écran désactivé (navigateur)');
        }).catch(err => {
            console.error('Erreur désactivation plein écran (navigateur):', err);
        });
    } else {
        console.log('État plein écran déjà correct ou impossible à changer');
    }
};

export const openExternalLink = (url: string) => {
    try {
        // Vérifier si on est dans Electron
        if (isElectron() && window.require) {
            try {
                // Méthode 1: Utiliser shell.openExternal directement
                const { shell } = window.require('electron');
                shell.openExternal(url);
                console.log('Ouverture du lien externe avec shell.openExternal:', url);
            } catch (shellError) {
                console.warn('Échec de shell.openExternal, tentative avec IPC:', shellError);
                try {
                    // Méthode 2: Utiliser IPC comme fallback (plus fiable sur Windows)
                    const { ipcRenderer } = window.require('electron');
                    ipcRenderer.send('open-external-link', url);
                    console.log('Ouverture du lien externe via IPC:', url);
                } catch (ipcError) {
                    console.warn('Échec de l\'IPC, utilisation du fallback navigateur:', ipcError);
                    window.open(url, '_blank');
                }
            }
        } else {
            // Fallback pour le navigateur (développement et web)
            window.open(url, '_blank');
            console.log('Ouverture du lien dans une nouvelle fenêtre (mode navigateur):', url);
        }
    } catch (e) {
        console.warn('Impossible d\'ouvrir le lien externe:', e);
        // Fallback ultime
        window.open(url, '_blank');
    }
};